<template>
    <el-tabs type="border-card">


        <el-tab-pane label="摄影师申请表" class="ApplyBox">
            <el-form ref="Form"  class="ApplyForm" status-icon aria-autocomplete="no" :model="Form" :rules="rules" label-width="1.4rem" size="mini">
              <div id="applyLabel" style="font-size: small;color: #00ae80;text-align: right">
              </div>
              <div class="Apply_title" v-if="!zhuanjia">申请成为摄影师</div>

            <el-form-item  label="聘书：" v-if="zhuanjia">
              <el-image
                v-for="(img, index) in contractAttaList"
                :key="index"
                :preview-teleported="true"
                @click.stop.prevent="clickImage"
                class="custom-image"
                :src="img"
                :preview-src-list="contractAttaList"
                fit="cover"
                lazy
              >
                <div slot="error" class="el-image__error">
                  暂无图片
                </div>
              </el-image>
            </el-form-item>

              <div class="custom-wrapper" v-if="!zhuanjia">
            <el-form-item prop="cameristName" label="姓名：">
                <el-input  v-model="Form.cameristName"  auto-complete="on" name="cameristName" :disabled="submitBut" ></el-input>
            </el-form-item>
            <el-form-item prop="VSex" label="性别：" >
                <el-radio-group v-model="Form.VSex" :disabled="submitBut">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="2">女</el-radio>
                </el-radio-group>
            </el-form-item>
              <el-form-item  label="民族：">
                <el-input  v-model="Form.nationality" auto-complete="on" name="nationality" :disabled="submitBut"></el-input>
              </el-form-item>
              <el-form-item  label="政治面貌：">
                <el-select v-model="Form.political" placeholder="请选择"  style="width:100%" :disabled="submitBut">
                  <el-option
                    v-for="item in political"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
            </el-form-item>


             <el-form-item prop="phone" label="电话号码：">
                <el-input  v-model="Form.phone" auto-complete="on" name="phone" :disabled="submitBut"></el-input>
            </el-form-item>

            <!-- <el-form-item prop="age" label="年龄">
                <el-input v-model="Form.age"></el-input>
            </el-form-item> -->


            <!-- <el-form-item prop="address" label="所在区域">

                <el-input  v-model="Form.address"></el-input>
            </el-form-item> -->
             <el-form-item  label="所在区域：">
                <el-select v-model="Form.province" placeholder="请选择"  style="width:32%" :disabled="submitBut">
                <el-option
                    v-for="item in province"
                    :key="item"
                    :label="item"
                    :value="item"
                ></el-option>
                </el-select>
                <el-select v-model="Form.city" placeholder="请选择"  style="width:32% ;" :disabled="submitBut">
                <el-option
                    v-for="item in cites"
                    :key="item"
                    :label="item"
                    :value="item"
                ></el-option>
                </el-select>
                <el-select v-model="Form.county" placeholder="请选择"  style="width:34% ;" :disabled="submitBut">
                <el-option
                    v-for="item in countes"
                    :key="item"
                    :label="item"
                    :value="item"
                ></el-option>
                </el-select>

            </el-form-item>
            <el-form-item label="详细地址：" >
                <el-input  v-model="Form.address" autoComplete="on" name="address" :disabled="submitBut"></el-input>
            </el-form-item>


              <el-form-item prop="sfzNumber" label="身份证号：" >
                <el-input  v-model="Form.sfzNumber" autoComplete="on" name="sfzNumber" :disabled="submitBut"></el-input>
              </el-form-item>

              <el-form-item prop="bankNumber" label="银行卡号：" >
                <el-input  v-model="Form.bankNumber" autoComplete="on" name="bankNumber" :disabled="submitBut"></el-input>
              </el-form-item>


              <el-form-item prop="bankName"  label="开户行：" >
                <el-input  v-model="Form.bankName" autoComplete="on" name="bankName" :disabled="submitBut"></el-input>
              </el-form-item>

              <el-form-item prop="VEmail" label="邮箱：">
                <el-input v-model="Form.VEmail" autoComplete="on" name="VEmail" :disabled="submitBut"></el-input>
              </el-form-item>

              <el-form-item label="网络联系方式：" >
                <el-input  v-model="Form.netPhone" autoComplete="on" name="netPhone" :disabled="submitBut"></el-input>
              </el-form-item>
<!--              belongAgreement:["中国摄影家协会","中国铁路文联摄影分会","其他"],-->
              <el-form-item  prop="belongAgreement"  label="所属摄影协会：" >
                <div  style="display: flex;flex-direction: column;">
                  <el-checkbox v-model="checkbox1" true-label="中国摄影家协会"  :disabled="submitBut">中国摄影家协会</el-checkbox>
                  <el-input v-if="checkbox1" v-model="Form.memberNumber1" placeholder="请输入中国摄影家协会会员编号" :disabled="submitBut"></el-input>

                  <el-checkbox  v-model="checkbox2" true-label="中国铁路文联摄影分会"  :disabled="submitBut">中国铁路文联摄影分会</el-checkbox>
                  <el-form-item label=" "  v-if="checkbox2" prop="memberNumber" class="formitem2" >
                    <el-input v-model="Form.memberNumber"  placeholder="请输入中国铁路文联摄影分会会员编号" :disabled="submitBut"></el-input>
                  </el-form-item>

                  <el-checkbox v-model="checkbox3" true-label="其他"  :disabled="submitBut">其他</el-checkbox>
                  <el-input  type="textarea" v-model="Form.otherAgree" v-if="checkbox3" placeholder="请输入其他所属摄影协会名称" :rows="4" maxlength="120" show-word-limit :disabled="submitBut"></el-input>
                </div>

                </el-form-item>

<!--              <el-form-item prop="belongAgreement"  label="所属摄影协会：">
                <el-select v-model="Form.belongAgreement" placeholder="请选择" multiple  style="width: 100%" @change="selectChangeAgree" :disabled="submitBut">
                  <el-option
                    v-for="item in belongAgreement"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>-->


<!--              <el-form-item prop="otherAgree" label="" v-if="visibleOther">
                <el-input  v-model="Form.otherAgree" autoComplete="on" name="otherAgree" :disabled="submitBut"></el-input>
              </el-form-item>-->
              <el-form-item prop="workAddress" label="工作单位：">
                <el-input  v-model="Form.workAddress" autoComplete="on" name="workAddress" :disabled="submitBut"></el-input>
              </el-form-item>

              <el-form-item label="职务：">
                <el-input  v-model="Form.workPost" autoComplete="on" name="workPost" :disabled="submitBut"></el-input>
              </el-form-item>


<!--              <el-form-item prop="memberNumber" label="会员编号：" :required="isHaveTo">
                <el-input  v-model="Form.memberNumber" autoComplete="on" name="memberNumber" :disabled="submitBut"></el-input>
              </el-form-item>-->


            <el-form-item prop="VContent" label="个人简介：">
                <el-input  type="textarea" v-model="Form.VContent" :rows="7" maxlength="200" show-word-limit :disabled="submitBut"></el-input>
            </el-form-item>

<!--              <el-form-item  class="touxiang">
                <el-upload
                  ref="uploadRef"
                  accept=".png,.jpg,.jpeg,.jpeg"
                  action="string"
                  :file-list="picfileList"
                  :action="imgUrlAction"
                  list-type="picture-card"
                  :auto-upload="true"
                  :limit="1"
                  :on-change="picChange"
                  :on-remove="picHandleRemove"
                  :on-success="handleAvatarSuccess3">
                  <i v-if="!cardImageUrl3" slot="default" class="el-icon-plus"/>
                </el-upload>
              </el-form-item>-->

              <el-form-item label="证件照：" class="touxiang">
                <el-upload
                  ref="uploadRef"
                  accept=".png,.jpg,.jpeg,.jpeg"
                  list-type="picture-card"
                  :file-list="picfileList"
                  :auto-upload="true"
                  :limit="1"
                  :action="imgUrlAction"
                  :class="{hide:submitBut}"
                  :on-change="picChange"
                  :on-success="handleAvatarSuccess3">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}" >
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                            <span
                              class="el-upload-list__item-preview"
                              @click="handlePictureCardPreview(file)"
                            >
                            <i class="el-icon-zoom-in"></i>
                            </span>

                            <span
                              v-if="!submitBut"
                              class="el-upload-list__item-delete"
                              @click="picHandleRemove(file)"
                            >
                            <i class="el-icon-delete"></i>
                            </span>
                        </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="50%" :src="dialogImageUrl" alt="">
                </el-dialog>
                <i class="el-icon-warning" style="font-size: xx-small;color: gainsboro;margin-top: 5px;">2寸白底照片,大小不超过3MB</i>
              </el-form-item>


              <el-form-item label="相关证书上传：" prop="VAccessory02" >
                <el-upload
                  accept=".png,.jpg,.jpeg,.jpeg"
                  list-type="picture-card"
                :action="imgUrlAction"
                  :class="{hide:submitBut}"
                  :before-upload="beforeupload"
                :on-change="imageChange2"
                :on-success="handleAvatarSuccess2"
                :on-error="uploadError"
                :file-list="zhengshuImg"
                ref="VAccessory02"
                :auto-upload="true">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}" >
                        <img
                            class="el-upload-list__item-thumbnail"
                            :src="file.url" alt=""
                        >
                        <span class="el-upload-list__item-actions">
                            <span
                            class="el-upload-list__item-preview"
                            @click="handlePictureCardPreview(file)"
                            >
                            <i class="el-icon-zoom-in"></i>
                            </span>

                            <span
                            v-if="!submitBut"
                            class="el-upload-list__item-delete"
                            @click="handleRemove(file,'VAccessory02')"
                            >
                            <i class="el-icon-delete"></i>
                            </span>

                        </span>
                    </div>

                </el-upload>
                <i class="el-icon-warning" style="font-size: xx-small;color: gainsboro;margin-top: 5px;">相关证书大小不能超过3MB</i>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="50%" :src="dialogImageUrl" alt="">
                </el-dialog>

            </el-form-item>

            <el-form-item prop="VServiceProtocol">
                <div style="display:flex;">
                    <el-checkbox v-model="Form.VServiceProtocol" v-if="!submitBut"></el-checkbox>
                    <p style="margin-left: .1rem;cursor: pointer;" >我已阅读《
                      <a href="javascript:void(0)" style="color: #3a8ee6" @click="openXieyi()">中国铁路图片库入库协议</a>
                      》及《<a href="javascript:void(0)" style="color: #3a8ee6" @click="openPrice()">费用标准</a>》并同意加入中国铁路图片库</p>
                </div>
                <!-- 协议提示框 -->
<!--                <el-dialog :title="agreementData.VTitle" :visible.sync="dialogAgreementVisible" style="margin-bottom: 100px">
                    &lt;!&ndash; 标题 &ndash;&gt;
                    <p class="argummentTitle">{{agreementData.VTitle}}</p>
                    <div class="argumentCon" v-html="agreementData.TContent"></div>
                    <div style="display: flex;align-items: center;">
                        <p style="margin-right: .1rem;">是否同意对平台免费开放非商业用途？</p>
                        <el-radio-group v-model="whether" >
                            <el-radio :label="0">同意</el-radio>
                            <el-radio :label="1">不同意</el-radio>
                        </el-radio-group>
                    </div>
                    <div style="display:flex;">
                        <el-checkbox v-model="Form.VServiceProtocol"></el-checkbox>
                        <p style="margin-left: .1rem;cursor: pointer;" @click="dialogAgreementVisible = true">我已仔细阅读并同意以上协议</p>
                    </div>
                    &lt;!&ndash; 确定按钮 &ndash;&gt;
                    <div class="okBtn">
                        <el-button @click="onOk()" type="primary" style="margin: 0 auto;">确定</el-button>
                    </div>
                </el-dialog>-->
            </el-form-item>
            <el-button type="primary"  v-if="!submitBut"  style="width: 100%;margin-top: 0.22rem;" @click.native.prevent="handleLogin" :disabled="isDisabled">提交</el-button>
              </div>
            </el-form>

<!--          <div v-if="zhengshuImg" style="padding: 20px 0px">
            <el-image :src=zhengshuImg  :lazy="true" style="max-height: 100%;max-width: 100%;"></el-image>
          </div>-->


        </el-tab-pane>


      <el-dialog title="中国铁路图片库入库协议" :visible.sync="dialogXieyiVisible" width="50%" height="30%" >
        <div style="display: flex;align-items: center;">
          <iframe :src="'static/pdf/web/viewer.html?file=' + url" frameborder="" style="width: 100%; height: 6rem;"></iframe>
        </div>
      </el-dialog>


      <el-dialog title="费用标准" :visible.sync="dialogPriceVisible" width="50%" height="30%" >
        <div style="display: flex;align-items: center;">
          <img :src="feiyongUrl" style="max-width: 100%;max-height: 100%">
        </div>
      </el-dialog>
<!--
      <el-tab-pane label="入库协议" class="ApplyBox">
        <iframe :src="'static/pdf/web/viewer.html?file=' + url" frameborder="" style="width: 100%; height: 6rem;"></iframe>
      </el-tab-pane>

      <el-tab-pane label="费用列表" class="ApplyBox">
          <img :src="feiyongUrl" style="max-width: 100%;max-height: 100%">
    </el-tab-pane>-->
    </el-tabs>

</template>

<script>
import addressData from '@/components/address-data.js'
import { jump,getUser,ValidateEmail,ValidateIdCard } from '@/untils/auth'
import {removeUser} from "../../../../untils/auth";

export default {
    name:'apply',

    components: {

    },
    data() {
        const validateEmail = (rule, value, callback) => {
          if (!value) {
            callback(new Error('电子邮箱不能为空'))
          } else if (!ValidateEmail(value)) {
            callback(new Error('电子邮箱格式不正确'))
          } else {
            callback()
          }
        }

      const validateIdCard = (rule, value, callback) => {
        if (!value) {
          callback(new Error('身份证号不能为空'))
        } else if (!ValidateIdCard(value)) {
          callback(new Error('身份证号格式不正确'))
        } else {
          callback()
        }
      }

      const bankAccountValid = (rule, value, callback) => {
        const strBin = '10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99'
        if (!value) {
          return callback(new Error('银行卡号不能为空'))
        } else if (!Number.isInteger(+value)) {
          callback(new Error('银行卡号必须全为数字'))
        } else if (value.trim().length < 12 || value.trim().length > 19) {
          callback(new Error('银行卡号长度必须在12到19之间'))
        } else if (strBin.indexOf(value.substring(0, 2)) === -1) {
          callback(new Error('银行卡号开头6位不符合规范'))
        } else {
          callback()
        }
      }

      return {
            zhuanjia: false,
            submitBut: false,
            // visibleOther:false,
            // visibleItem:true,
            // isHaveTo:false,
            status:0,
            isDisabled: false,
            // 图片上传
            imgUrlAction: window.IPConfig.IP + '/uploadImg.do',
            cardImageUrl3: '',
            picfileList:[],
            contractAttaList:[],
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            zhengshuImg:[],

           checkbox1:false,
           checkbox2:false,
           checkbox3:false,
           belongAgreementArr:[],

            Form:{
                VPicture: '',
                cameristName:'',
                VSex:'',
                phone:'',
                nationality:'',
                political:'',
                VEmail:'',
                workAddress:'',
                workPost:'',
                belongAgreement:'',

                otherAgree:'',
                memberNumber:'',
                memberNumber1:'',

                netPhone:'',
                bankNumber:'',
                sfzNumber:'',
                bankName:'',
                // age:'',
                province:null,//省份
                city:null,//城市
                county:null,
                address:'',
                VContent:'',
                VServiceProtocol:false,
                IdCardImageUrl:[],
            },
            province:Object.keys(addressData),
            political:[],
            // belongAgreement:["中国摄影家协会","中国铁路文联摄影分会","其他"],
            rules:{

               cameristName:[
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { pattern:/^[\u4E00-\u9FA5]{2,6}$/, message: '请输入正确的名字', trigger: 'blur' }
                ],
                VSex:{ required: true, message: '请选择性别', trigger: 'blur' },
                phone:[
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern:/^1[3456789]\d{9}$/ , message: '请输入正确的手机号', trigger: 'blur' }
                ],
                VEmail:[
                  { required: true, message: '请输入邮箱', trigger: 'blur', validator: validateEmail },
                ],

              workAddress:[
                {message: '请输入工作单位', trigger: 'blur' },
              ],
              belongAgreement: [{
                required: true,
                trigger: 'blur',
                validator: (rule, value, callback) => {
                  callback()
                }
              }],
              otherAgree:[
                { required: true, message: '请输入其他指的具体协会', trigger: 'blur' },
              ],

              memberNumber:[
                { required: true,message: '请输入会员编号', trigger: 'blur' },
              ],
                sfzNumber:[
                  { required: true, message: '请输入正确的身份证号', trigger: 'blur', validator: validateIdCard },
                ],

                bankNumber:[
                  { required: true, message: '请输入正确的银行卡号', trigger: 'blur' ,validator: bankAccountValid},
                ],
                bankName:[
                  { required: true, message: '请输入开户行', trigger: 'blur' },
                ],
              // age:[
                //     { required: true, message: '请输入年龄', trigger: 'blur' },
                //     { pattern:/^([2-5]\d)|60$/ , message: '请输入正确的手机号', trigger: 'blur' }
                // ],
                // address:{ required: true, message: '请选择地址', trigger: 'blur' },
                VContent:{ required: true, message: '请输入简介', trigger: 'blur' },
                VServiceProtocol:[
                    {
                        validator: function (rule, value, callback) {
                        // rule 代表当前的规则  无意义
                        // value 代表当前的值 checked的值
                        // callback  为回调函数
                        if (value) {
                            // 为真  执行 回调函数执行
                            callback()
                        } else {
                            callback(new Error('您未同意用户协议及条款'))
                        }
                        }
                    }
                ],
            },
            // 协议内容
            argContent: '内容',
            // 弹框中是否阅读协议选项
            readAgreement: false,
            // 协议提示框
            dialogAgreementVisible: false,
            dialogXieyiVisible: false,
            dialogPriceVisible: false,
            // 是否同意非商业用途
            whether: 0,
            // 协议
            agreementData: {},
            feiyongUrl:'',
            url:'',
            total: 0,
        }
    },
    created (){

      if(getUser()) {

        // this.url = encodeURIComponent(window.IPConfig.IP + '/files/previewXieyi');
        this.url = encodeURIComponent(window.IPConfig.IP + "/files/previewXieyi");
        // this.getPDF();


        var VUserId = JSON.parse(getUser()).principal.VUserId
        var VNickname = JSON.parse(getUser()).principal.VNickname
        this.Form.cameristName = VNickname
        this.axios.post(window.IPConfig.IP + "/tBUserRole/queryAll.do", {VUserId: VUserId}).then((res) => {
          if (res.status == 200) {
            if (res.data.status == 200) {
              if (res.data.obj.length) {
                res.data.obj.forEach((item) => {
                  if (item.vroleId == "dd25206efde9d484af0e4eb0613c480d") {//教师用户
                    this.zhuanjia = true
                  }
                });
              }
            }
          }
        });

        this.onApplyInfo(VUserId);
        this.onAgreementInfo();

        /*配置表*/
        this.axios
          .post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=feiyong").then((res) => {
          if (res.status == 200) {
            if (res.data.status == 200) {
              this.feiyongUrl = res.data.url + res.data.obj[0].VLine;
            }
          }
        });

        this.axios
          .post(window.IPConfig.IP + "/tbBasicConfig/getTBConfigDetail.do?VKey=zhengzhimianmao").then((res) => {
          if (res.status == 200) {
            console.log(res)
            if (res.data.status == 200) {
              res.data.obj.forEach(item => {
                this.political.push(item.VName);
              });
            }
          }
        });

        /*this.axios
          .post(window.IPConfig.IP + "/tbBasicConfig/getTBConfigDetail.do?VKey=sheyingxiehui").then((res) => {
          if (res.status == 200) {
            console.log(res)
            if (res.data.status == 200) {
              res.data.obj.forEach(item => {
                this.belongAgreement.push(item.VName);
              });
            }
          }
        });*/

      }
    },
    methods:{
      jump,



      getPDF() {
        request({
          url: "/files/queryPage",
          method: "post",
        }).then((res) => {
          this.total = res.data.obj || 0;
        });
      },
      // 查询申请记录
      onApplyInfo (VUserId){
        this.axios.post(window.IPConfig.IP + '/tBusCamerist/getByVUserId.do?VUserId='+VUserId).then((response) => {
          if (response.status == 200) {
            if (response.data.status == 200) {
              var obj = response.data.obj;
              if (obj.vaccessory02 !=null && obj.vaccessory02 !=''){
                obj.vaccessory02.split(',').forEach((item) => {
                  this.zhengshuImg.push({url:response.data.url+item});
                  this.Form.IdCardImageUrl.push(item);
                });
              }
              if (obj.vstatus==0){
                  document.getElementById("applyLabel").innerHTML="已提交申请!，请等待管理员审核";
                  this.submitBut=true;
              }else if (obj.vstatus==1){
                document.getElementById("applyLabel").innerHTML="";
                this.submitBut=true;
              }else if (obj.vstatus==2){
                document.getElementById("applyLabel").innerHTML="申请被驳回："+obj.vstatusText;
              }else{
                // document.getElementById("applyLabel").innerHTML="";
              }

              if (obj.vpicture !=null && obj.vpicture !=''){
                  this.cardImageUrl3 =obj.vpicture;
                  this.Form.VPicture =obj.vpicture;
                  this.picfileList.push({url:response.data.url+obj.vpicture});
                  this.$refs.uploadRef.$children[1].$el.style.display='none'
              }

              console.log(obj.contractAtta)
              if (obj.contractAtta !=null && obj.contractAtta !=''){
                obj.contractAtta.split(',').forEach((item) => {
                  this.contractAttaList.push(response.data.url+item)
                });
              }



              this.Form.sfzNumber=obj.sfzNumber
              this.Form.netPhone=obj.netPhone
              this.Form.workAddress=obj.workAddress
              this.Form.workPost=obj.workPost

// belongAgreement:["中国摄影家协会","中国铁路文联摄影分会","其他"],
              var belongAgreement = obj.belongAgreement
              // console.log(JSON.parse(belongAgreement))
              try {
                const argeementArr = JSON.parse(belongAgreement);
                for (let i=0;i<argeementArr.length;i++){
                  console.log(argeementArr[i].name)
                  if (argeementArr[i].name=="中国摄影家协会"){
                    this.checkbox1=true
                    this.Form.memberNumber1=argeementArr[i].memberNumber1
                  }
                  if (argeementArr[i].name=="中国铁路文联摄影分会"){
                    this.checkbox2=true
                    this.Form.memberNumber=argeementArr[i].memberNumber
                  }
                  if (argeementArr[i].name=="其他"){
                    this.checkbox3=true
                    this.Form.otherAgree=argeementArr[i].otherAgree
                  }
                }
                // this.Form.belongAgreement=selectOption
              } catch (e) {
                console.error('Error parsing JSON:', e);
              }


              // this.Form.memberNumber=obj.memberNumber
              this.Form.bankName=obj.bankName
              this.Form.bankNumber=obj.bankNumber
              this.Form.VSex=obj.vsex

              this.Form.cameristName=obj.cameristName
              this.Form.nationality=obj.nationality
              this.Form.political=obj.political

              this.Form.phone=obj.phone
              this.Form.VEmail=obj.vemail
              this.Form.VContent=obj.vcontent
              var vaddress = obj.vaddress
              var addressJson = JSON.parse(vaddress);
              this.Form.province=addressJson.province
              this.Form.city =addressJson.city
              this.Form.county=addressJson.county
              this.Form.address =addressJson.address
            }
          }
        })
      },


        // 协议内容
        onAgreementInfo (){
            this.axios.post(window.IPConfig.IP + '/tBusServiceAgreement/getById.do?Id=c9f89858d926ff72f5cfc9c30128a3ce').then((response) => {
                if (response.status == 200) {
                    if (response.data.status == 200) {
                        // 内容赋值
                        this.agreementData = response.data.obj;
                    }
                }
            })
        },

        // 协议确定
        onOk (){
            // 判断是否同意协议,如果同意，修改外部状态，隐藏协议
            // 是否同意非商业用途 this.whether = 0
            //this.readAgreement
            if(this.Form.VServiceProtocol){
                // 协议提示框
                this.dialogAgreementVisible = false;
            }else{
                this.$message.error('请同意协议');
            }
        },


      openXieyi(){
          this.dialogXieyiVisible = true;
      },

      openPrice(){
        this.dialogPriceVisible = true;
      },

        // 身份证上传
/*        handleAvatarSuccess(res, file) {
            this.cardImageUrl = file.response.obj.vattachmentRemotePath;
        },*/



      // 头像上传
      handleAvatarSuccess3 (res, file){
        // 隐藏上传按钮
        this.cardImageUrl3 = file.response.obj.vattachmentRemotePath;
        this.$refs.uploadRef.$children[1].$el.style.display = 'none'
      },

      picHandleRemove(file) {
        console.log(this.cardImageUrl3)
        let fileList = this.$refs.uploadRef.uploadFiles;
        let index = fileList.findIndex( fileItem => {
          return fileItem.uid === file.uid
        })
        fileList.splice(index, 1)

        this.cardImageUrl3="";
        this.$refs.uploadRef.$children[1].$el.style.display = 'block'
      },

      picChange (file, fileList, name) {
        console.log("change")
        const size = file.size / 1024 / 1024
        if (size > 3) {
          this.$message.error('警告，大小必须小于3MB');
          if (this.$refs.uploadRef) {
            this.$refs.uploadRef.clearFiles() // 清除上传的文件
          }
          return
        }
      },

      uploadError(res) {
        this.$message.error('文件上传失败，请检查文件大小或文件格式');
      },


        handleLogin() {
// belongAgreement:["中国摄影家协会","中国铁路文联摄影分会","其他"],
        this.belongAgreementArr=[]



            this.$refs.Form.validate(valid => {

              if (valid) {
                if (this.checkbox1 !=false){
                  this.belongAgreementArr.push({name: this.checkbox1,memberNumber:this.Form.memberNumber1})
                }

                if (this.checkbox2 !=false){
                  if (this.Form.memberNumber ==null || this.Form.memberNumber ==""){
                    this.$message({
                      type: 'error',
                      message: '请输入中国铁路文联摄影分会会员编号'
                    });
                    return false;
                  }
                }
                if (this.checkbox2 !=false){
                  this.belongAgreementArr.push({name: this.checkbox2,memberNumber:this.Form.memberNumber})
                }
                if (this.checkbox3 !=false){
                  this.belongAgreementArr.push({name: this.checkbox3,otherAgree:this.Form.otherAgree})
                }

                if (this.belongAgreementArr.length==0){
                  this.$message({
                    type: 'error',
                    message: '请选择所属摄影协会'
                  });
                  return false;
                }

                var files = this.$refs.uploadRef.uploadFiles[0];
                if (files==undefined){
                  this.$message({
                    type: 'error',
                    message: '请上传二寸白底证件照'
                  });
                  return false;
                }

                // 获取详细地址
                let addressInfo = {
                  province: this.Form.province == null ? '' : this.Form.province,
                  city: this.Form.city == null ? '' : this.Form.city,
                  county: this.Form.county == null ? '' : this.Form.county,
                  address: this.Form.address == null ? '' : this.Form.address
                };
                addressInfo = JSON.stringify(addressInfo)

                var data = {
                  cameristName: this.Form.cameristName,
                  VSex: this.Form.VSex,
                  phone: this.Form.phone,
                  nationality: this.Form.nationality,
                  political: this.Form.political,
                  VEmail: this.Form.VEmail,
                  VAddress: addressInfo,
                  VPicture: this.cardImageUrl3,
                  // VAccessory: this.cardImageUrl,
                  VAccessory02: this.Form.IdCardImageUrl.join(","),
                  VContent: this.Form.VContent,
                  VServiceProtocol: this.Form.VServiceProtocol ? '1' : '0',
                  VUserId: JSON.parse(getUser()).principal.VUserId,
                  createdBy: JSON.parse(getUser()).principal.VUserId,
                  VSystemId: this.$store.state.user.VSystemId,
                  VSource: 1,
                  VStatus:0,
                  workAddress: this.Form.workAddress,
                  workPost: this.Form.workPost,
                  netPhone: this.Form.netPhone,
                  sfzNumber: this.Form.sfzNumber,
                  bankNumber: this.Form.bankNumber,
                  bankName: this.Form.bankName,
                  memberNumber: this.Form.memberNumber,
                  belongAgreement: JSON.stringify(this.belongAgreementArr),
                  otherAgree: this.Form.otherAgree
                }

                if(getUser()) {
                  this.axios.post(window.IPConfig.IP + '/tBusCamerist/add.do', data).then((response) => {
                    if (response.data.status == 200) {
                      // this.Form = response.data.obj
                      this.$message({
                        type: 'success',
                        message: '提交成功!，请等待管理员审核'
                      });
                      this.isDisabled = true
                      this.Form = {};
                      window.location.reload();

                    }else{
                      this.$message({
                        type: 'warning',
                        center: true,
                        message: response.data.msg
                      });
                      removeUser();
                      this.jump('/login')
                    }
                  })
                }else{
                  this.jump('/login')
                }

              } else {
                return false;
              }
            })

        },

      // 证书上传
      handleAvatarSuccess2 (res, file){
        console.log(res)
        this.Form.IdCardImageUrl.push(file.response.obj.vattachmentRemotePath);
      },

      imageChange2 (file, fileList, name) {
        let index = fileList.findIndex( fileItem => {
          return fileItem.uid === file.uid
        })
        const size = file.size / 1024 / 1024
        if (size > 3) {
          this.$message.error('警告，大小必须小于3MB');
          fileList.splice(index, 1)
          return
        }

      },

      handleRemove(file,upload) {
          console.log(file)
        let fileList = this.$refs.VAccessory02.uploadFiles;
        let index = fileList.findIndex( fileItem => {
          return fileItem.uid === file.uid
        })
        fileList.splice(index, 1)
          for (let i =0;i < this.Form.IdCardImageUrl.length;i++){
            let attach = this.Form.IdCardImageUrl[i];
            if (file.url.indexOf(attach) >0 ){
              this.Form.IdCardImageUrl.splice(i,1)
            }
          }
        },

        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        beforeupload (file) {
            console.log(file)

        },


/*
        selectChangeAgree (val) {
            console.log(val)
            this.isHaveTo =false
            this.visibleOther =false

            if (val.includes('其他')){
              this.visibleOther =true
            }

            if(val.includes('中国铁路文联摄影分会')){
              this.isHaveTo =true
            }
        },
*/


      /**
       * @description: 预览的图片添加下载按钮
       */
      clickImage() {
        let wrapper = document.getElementsByClassName('el-image-viewer__actions__inner');
        if (wrapper.length >0) {
          for (var i=0;i<wrapper.length;i++){
            var tagname = wrapper[i].getElementsByTagName("i");
            if (tagname.length==7){
              let downImg = document.createElement('i');
              downImg.setAttribute('class', 'el-icon-download');
              wrapper[i].appendChild(downImg);
              this.wrapperElem = wrapper[i];
              this.cusClickHandler();
            }
          }
        }
      },


      /**
       * @description: 预览的图片给下载按钮添加事件
       */
      cusClickHandler() {
        this.wrapperElem.addEventListener('click', () => {
          const imgUrl = document.getElementsByClassName('el-image-viewer__img')[0].src;
          window.open(window.IPConfig.IP + '/files/downloadFile?file='+imgUrl,"_blank")
        });
      },

    },
    computed: {
    // 城市
    cites () {
      const province = this.Form.province
      let data = []
      if (province) {
        data = Object.keys(addressData[province])
      }
      return   data
    },
    // 县城
    countes () {
      const city = this.Form.city
      const province = this.Form.province
      let data = []

      if (city) {
        data = addressData[province][city]
      }
      return data
    }
  }
}
</script>

<style lang="stylus" scoped>

    .ApplyBox {
        padding: 0.3rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .ApplyForm {
        width: 68%;
    }
    .ApplyForm .Apply_title {
        text-align: center;
        font-size: 0.24rem;
        font-weight: bold;
        margin: 0 0 0.3rem;
    }
    .ApplyBox >>> .touxiang .el-form-item__label:before {
      content: '*' !important;
      color: #F56C6C !important;
      margin-right: 4px !important;
    }

    .ApplyBox >>>.el-upload-list--picture-card .el-upload-list__item {
    width: 1rem;
    height: 1rem;
    }
    .ApplyBox >>>.el-upload-list--picture-card .el-upload-list__item-actions {
    width: 1rem;
    height: 1rem;
    }
    .ApplyBox >>>.el-upload--picture-card {
    width: 1rem;
    height: 1rem;
    line-height: 1rem;
    }

    .ApplyBox >>>div .formitem2 .el-form-item__label{
      width:0px !important;
    }
    .ApplyBox >>>div .formitem2 .el-form-item__content{
      margin-left: 15px !important;
    }

    .ApplyBox >>>div .el-form-item__label{
      width: 2.05rem !important;
    }



    .ApplyBox >>>div .el-form-item__content{
      margin-left: 2.05rem !important;
    }

    .custom-image {
      width: 30%;
      height: 30%;
      margin-right: 10px;
    }

    .el-image__error {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background-color: #f5f5f5;
      color: #999;
      font-size: 14px;
    }
    // .divwrap {
    // height: 50%;
    // width: 100%;
    // z-index: 99;
    // }
    .el-dialog{
      margin-top: 20px !important;
    }

    .author {
        width: 100%;
        height: 1.6rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 0.3rem;
    }
    .author > div {
        width: 1.2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .hide /deep/ .el-upload--picture-card {
        display: none !important

    }
    // 弹出框协议内容
    .argummentTitle{
        width: 100%;
        text-align: center;
        font-size: .3rem;
        font-weight: 700;
    }
    .okBtn{
        position: absolute;
        bottom: .1rem;
        right: .5rem;
    }
    .argumentCon{
        text-indent: 2em;
        line-height: 2;
        height: 4rem;
        overflow-y: scroll;
    }

    .el-input {
      display: inline-block;

      input {
        background-color: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        color: $light_gray;
        height: 47px;
        caret-color: $cursor;

        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px #f8f9fa inset !important;
          -webkit-text-fill-color: $cursor !important;
        }
      }
    }

</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/components/my/apply.vue